var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1494 7.76815C25.5629 7.20759 24.8667 6.76292 24.1003 6.45954C23.334 6.15615 22.5126 6 21.6831 6C20.8535 6 20.0321 6.15615 19.2658 6.45954C18.4994 6.76292 17.8032 7.20759 17.2167 7.76815L15.9997 8.93095L14.7826 7.76815C13.5981 6.6364 11.9915 6.00059 10.3163 6.00059C8.64114 6.00059 7.03455 6.6364 5.85001 7.76815C4.66547 8.89989 4 10.4349 4 12.0354C4 13.6359 4.66547 15.1709 5.85001 16.3027L7.06705 17.4655L15.9997 26L24.9323 17.4655L26.1494 16.3027C26.7361 15.7424 27.2015 15.0771 27.519 14.3449C27.8366 13.6128 28 12.828 28 12.0354C28 11.2429 27.8366 10.4581 27.519 9.72587C27.2015 8.99368 26.7361 8.32844 26.1494 7.76815V7.76815Z",
    stroke: "#181D27",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteSidebar);
export default __webpack_public_path__ + "static/media/favoriteSidebar.96aaf6a6623489a2bca0dcdea38038c3.svg";
export { ForwardRef as ReactComponent };